var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 55,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M3 51.863 18.02 5.642c.13-.4.347-.763.637-1.063.289-.3.641-.529 1.029-.667a15.46 15.46 0 0 1 9.989-.161c7.49 2.433 10.813 9.191 16.638 11.084q4.993 1.622 8.324.433a2.562 2.562 0 0 1 2.693.607c.346.348.588.79.7 1.274.112.485.09.994-.066 1.471L49.62 44.3c-.13.398-.348.762-.637 1.063s-.642.528-1.03.667a15.46 15.46 0 0 1-9.988.16C30.475 43.757 27.15 37 19.66 34.566c-3.684-1.197-7.693-.956-11.26.679"
  })));
};
export default SvgFlag;